import React, { useState } from 'react';
import { Step } from '../../types/wizard';
import { setAllowWEItoChooseColors, validateWizardSteps, wizardStore } from '../../stores/wizard';
import { useSnapshot } from 'valtio';

interface ColorDisclaimerProps {
  step?: Step;
  title: string;
}

const ColorDisclaimer: React.FC<ColorDisclaimerProps> = ({ step, title }) => {
  const wizSnap = useSnapshot(wizardStore);
  const [isColorSelected, setIsColorSelected] = useState<boolean>(step ? wizSnap.emblemData[step?.id]?.allowWEItoChoose : false);
  const showToggle = !step?.hideWEtoChooseMyColors;
  const message = step?.disclaimer?.message
    ?.replace(/World Emblem/gi, "Stahls' Canada ULC")
    ?.replace(/color/gi, (match) =>
      match[0] === 'C' ? 'Colour' : 'colour'
    );

  const handleClick = () => {
    setIsColorSelected(!isColorSelected);
    setAllowWEItoChooseColors(step?.id as string, !isColorSelected);
    validateWizardSteps(step?.id);
  };

  return (
    <div className="text-gray-700 my-4">
      {message && <div className="flex flex-row justify-start items-center pb-4 text-sm"
        dangerouslySetInnerHTML={{ __html: message }}></div>
      }
      {showToggle &&
        <div className="flex flex-row justify-start items-center gap-4">
          <label className="font-bold">{title}</label>
          <div
            className={`relative flex items-center w-10 h-5 p-0.5 cursor-pointer rounded-full 
            ${isColorSelected ? 'bg-blue-500' : 'bg-gray-300'}`}
            onClick={handleClick}
          >
            <div
              className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform duration-300
              ${isColorSelected ? 'translate-x-5' : 'translate-x-0'}`}
            ></div>
          </div>
        </div>
      }
      {isColorSelected && (
        <div className="flex flex-col text-sm">
          <span className="mt-4 mb-4">
            The Stahls Design Team will select the colours based on your uploaded
            design and will match colours as closely as possible. Stahls is not
            responsible for design changes as a result of our colour selection on approved
            designs.
          </span>
          <span className="font-bold mb-4">
            Please be aware that this option may add up to two days to your design's
            turn-around time.
          </span>
        </div>
      )}
    </div>
  );
};

export default ColorDisclaimer;